import React from "react";

const EmptyState = ({
  icon: Icon,          // pass the lucide icon component (e.g., Award)
  iconSize = 48,
  title,
  message,
  actionLabel,
  onAction,           // onClick handler (e.g., () => navigate("/route"))
  className = "",
}) => {
  return (
    <div className={`empty-state ${className}`}>
      {Icon && <Icon size={iconSize} />}
      {title && <h3>{title}</h3>}
      {message && <p>{message}</p>}
      {actionLabel && onAction && (
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <button className="btn btn-primary" onClick={onAction}>
            {actionLabel}
          </button>
        </div>
      )}
    </div>
  );
};

export default EmptyState;